import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const OrdersQuery = gql`
  query($first: Int) {
    orderHistory(first: $first) {
      id
      orderNumber
      createdAt
      grandTotal
      status
      externalState {
        id
        name
      }
      invoices {
        id
        invoiceNumber
        type
      }
      currency {
        id
        value
      }
    }
  }
`;

interface IInputProps {
  children?: any;
  first?: number;
}

interface IResponse {
  data: any;
}

class GetOrdersQuery extends React.PureComponent<ChildProps<IInputProps, Response>> {
  public render() {
    const { orders }: any = this.props;
    return this.props.children({
      orders
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(OrdersQuery, {
    name: 'orders',
    options: props => ({
      variables: {
        first: props.first
      }
    })
  })
)(GetOrdersQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Orders/Orders.tsx